export default {
    "flashcards.title": "Flashcards",
    "flashcards.title_highlight": "Interactives",
    "flashcards.subtitle": "Mémorisez les dates et faits clés grâce à la répétition espacée.",

    "flashcards.nav.back_themes": "Retour aux thématiques",
    "flashcards.nav.download_pdf": "Télécharger en PDF",
    "flashcards.nav.flip_question": "Voir la question",
    "flashcards.nav.flip_answer": "Voir la réponse",

    "flashcards.card.question": "QUESTION",
    "flashcards.card.answer": "RÉPONSE",
    "flashcards.card.click_flip": "Cliquez pour retourner",

    "flashcards.status.no_flashcards": "Aucune flashcard disponible",
    "flashcards.status.no_flashcards_desc": "Les flashcards de cette catégorie arrivent bientôt !",
    "flashcards.status.back": "Retour",

    "flashcards.result.title": "Série terminée !",
    "flashcards.result.subtitle": "Bien joué ! Vous avez passé toutes les cartes de ce thème.",
    "flashcards.result.retry": "Recommencer",
    "flashcards.result.other_theme": "Choisir un autre thème",
    "flashcards.result.unlock_pro": "DÉBLOQUER TOUT L'ACCÈS",
    "flashcards.result.unlock_pro_desc": "Accédez à toutes les cartes et thématiques.",

    "flashcards.badges.new": "Nouveau Badge !",
    "flashcards.badges.congrats": "Félicitations pour votre persévérance.",
    "flashcards.badges.close": "Continuer",

    "flashcards.pdf.title": "Flashcards - {{theme}}",
    "flashcards.pdf.footer": "Document généré par CitoyenPro - citoyenpro.nnt-quebec.com",
    "flashcards.pdf.label_answer": "Réponse"
};
